/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState } from 'react'
import { getRequestOptions, postRequestOptions } from '../helpers/Fetchwrapper'
import { Table } from 'react-bootstrap-v5'
import { useParams, Link, useHistory } from 'react-router-dom'
import { KTSVG } from '../../_metronic/helpers'
import Swal from 'sweetalert2'
import { AppContext } from '../context/AppContext'

interface RouteParams {
	id: string;
}

const num = (value: any, digits = 5) => {
	const parsed = Number(value)
	return value === null || value === undefined || !Number.isFinite(parsed) ? '' : parseFloat(parsed.toFixed(digits))
}

function ProductConversionDetails() {
	const { id }: RouteParams = useParams()
	const history = useHistory()
	const { currentUser } = useContext(AppContext)
	const canViewCost = Number(currentUser?.id_roles) === 3 || Number(currentUser?.id_roles) === 4
	const [conversion, setConversion] = useState<any>(null)
	const [rows, setRows] = useState<any[]>([])
	const [issues, setIssues] = useState<any[]>([])
	const [returns, setReturns] = useState<any[]>([])
	const [deleting, setDeleting] = useState(false)

	useEffect(() => {
		fetch(process.env.REACT_APP_API_URL + 'product-conversions/' + id, getRequestOptions())
			.then((resp) => resp.json())
			.then((resp) => {
				if (!resp.success) {
					Swal.fire({ icon: 'error', title: 'Error', text: resp.errorMessage || 'Unable to load the conversion.' })
						.then(() => history.push('/product-conversions'))
					return
				}
				setConversion(resp.data)
				setRows(resp.rows || [])
				setIssues(resp.issues || [])
				setReturns(resp.returns || [])
			})
			.catch((error) => console.log(error, 'catch the hoop'))
	}, [id])

	const handleDelete = async () => {
		const confirm = await Swal.fire({
			title: 'Are you sure?',
			text: 'This will permanently delete this conversion: the source packs go back into stock, the converted packs come out, the packing items are reversed and the accounting voucher is removed.',
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#ec008c',
			cancelButtonText: 'Cancel',
			confirmButtonText: 'Yes, Delete',
		})
		if (!confirm.isConfirmed) {
			return
		}

		setDeleting(true)
		try {
			const response = await fetch(`${process.env.REACT_APP_API_URL}product-conversions/delete/${id}`, postRequestOptions({}))
			const data = await response.json()
			if (data.success) {
				Swal.fire({ icon: 'success', title: 'Success', text: data.successMessage }).then(() => history.push('/product-conversions'))
			} else {
				Swal.fire({ icon: 'error', title: 'Error', text: data.errorMessage || data.errors || 'Action failed.' })
			}
		} catch (error) {
			Swal.fire({ icon: 'error', title: 'Error', text: 'An error occurred.' })
		} finally {
			setDeleting(false)
		}
	}

	if (!conversion) {
		return (
			<div className="card card-custom">
				<div className="card-body">Loading...</div>
			</div>
		)
	}

	const unit = conversion.unitName || ''
	const sourceTotal = Number(conversion.sourceQuantity) * Number(conversion.sourceSize)

	const itemTable = (lines: any[]) => (
		<Table size="sm" bordered hover>
			<thead>
				<tr>
					<th>SL</th>
					<th>Item</th>
					<th>Category</th>
					<th>Quantity</th>
					<th>Unit</th>
					{canViewCost && <th>Rate</th>}
					{canViewCost && <th>Amount</th>}
				</tr>
			</thead>
			<tbody>
				{lines.length === 0 && (
					<tr>
						<td colSpan={canViewCost ? 7 : 5} className="text-center text-muted">None</td>
					</tr>
				)}
				{lines.map((line, index) => (
					<tr key={line.idItems}>
						<td>{index + 1}</td>
						<td>{line.itemName}</td>
						<td>{line.categoryName}</td>
						<td>{num(line.quantity)}</td>
						<td>{line.unitName}</td>
						{canViewCost && <td>{num(line.rate, 4)}</td>}
						{canViewCost && <td>{num(line.amount, 2)}</td>}
					</tr>
				))}
			</tbody>
		</Table>
	)

	return (
		<div className="card card-custom">
			<div className="card-header">
				<div className="card-title">
					<KTSVG path="/media/svg/icons/Text/Bullet-list.svg" className="svg-icon-1 svg-icon-primary" />
					<span className="text fw-bolder" style={{ marginLeft: '10px' }}>
						Product Conversion Details
					</span>
				</div>
				<div className="card-toolbar">
					{conversion.canDelete &&
						<button type="button" className="btn btn-sm btn-danger me-2" disabled={deleting} onClick={handleDelete}>
							{deleting ? 'Deleting...' : 'Delete'}
						</button>
					}
					<Link to="/product-conversions" className="btn btn-sm btn-secondary">Back</Link>
				</div>
			</div>
			<div className="card-body">
				<Table size="sm" bordered>
					<tbody>
						<tr>
							<td width="30%">Conversion No</td>
							<td> : {conversion.conversionNo}</td>
						</tr>
						<tr>
							<td>Conversion Date</td>
							<td> : {conversion.conversionDate}</td>
						</tr>
						<tr>
							<td>Project</td>
							<td> : {conversion.projectName}</td>
						</tr>
						<tr>
							<td>Finished Good Warehouse</td>
							<td> : {conversion.warehouseName}</td>
						</tr>
						<tr>
							<td>Packing Item Warehouse</td>
							<td> : {conversion.packingItemWarehouseName}</td>
						</tr>
						<tr>
							<td>Product</td>
							<td> : {conversion.itemName} ({conversion.itemCode})</td>
						</tr>
						{conversion.voucherNo &&
							<tr>
								<td>Voucher</td>
								<td> : <Link to={`/transaction-details/${conversion.idAccVouchers}`}>{conversion.voucherNo}</Link></td>
							</tr>
						}
						{conversion.remarks &&
							<tr>
								<td>Remarks</td>
								<td> : {conversion.remarks}</td>
							</tr>
						}
						<tr>
							<td>Created By</td>
							<td> : {conversion.createdBy}</td>
						</tr>
					</tbody>
				</Table>

				<h5 className="mt-5 mb-3">Converted From</h5>
				<Table size="sm" bordered hover>
					<thead>
						<tr>
							<th>SL</th>
							<th>Packing</th>
							<th>Size</th>
							<th>Quantity</th>
							<th>Total</th>
							{canViewCost && <th>Cost/Per Unit</th>}
							{canViewCost && <th>Total Cost</th>}
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>1</td>
							<td>{conversion.sourcePacking} {unit}</td>
							<td>{num(conversion.sourceSize)} {unit}</td>
							<td>{num(conversion.sourceQuantity)}</td>
							<td>{num(sourceTotal)} {unit}</td>
							{canViewCost && <td>{num(conversion.sourceRate, 4)}</td>}
							{canViewCost && <td>{num(conversion.sourceAmount, 2)}</td>}
						</tr>
					</tbody>
				</Table>

				<h5 className="mt-5 mb-3">Converted To</h5>
				<Table size="sm" bordered hover>
					<thead>
						<tr>
							<th>SL</th>
							<th>Packing</th>
							<th>Size</th>
							<th>BOM</th>
							<th>Quantity</th>
							<th>Total</th>
							{canViewCost && <th>Cost/Per Unit</th>}
							{canViewCost && <th>Total Cost</th>}
						</tr>
					</thead>
					<tbody>
						{rows.map((row, index) => (
							<tr key={row.idProductConversionRows}>
								<td>{index + 1}</td>
								<td>{row.packing} {unit}</td>
								<td>{num(row.size)} {unit}</td>
								<td>{row.bomName}</td>
								<td>{num(row.quantity)}</td>
								<td>{num(Number(row.quantity) * Number(row.size))} {unit}</td>
								{canViewCost && <td>{num(row.costPerUnit, 4)}</td>}
								{canViewCost && <td>{num(row.totalCost, 2)}</td>}
							</tr>
						))}
					</tbody>
				</Table>

				<h5 className="mt-5 mb-3">Packing Items Issued</h5>
				{itemTable(issues)}

				<h5 className="mt-5 mb-3">Recovered Packing Items</h5>
				{itemTable(returns)}
			</div>
		</div>
	)
}

export default ProductConversionDetails
